module.exports = __webpack_public_path__ + "img/PurposeAndNeed_01_purpose.934df594.jpg";